module.exports = __webpack_public_path__ + "img/profile-pic.27da4326.jpg";